import {
  ERROR_NO_USES_REMAIN,
  MESSAGE_ERROR_USED,
} from '@/app/[locale]/store/_consts/discounts';

import type { DiscountError, GetInvalidOrExpiredDiscountError } from './types';

export const _getInvalidOrExpiredDiscountError = ({
  invalidReason,
  valid,
}: GetInvalidOrExpiredDiscountError): DiscountError => {
  if (!valid) {
    if (invalidReason === ERROR_NO_USES_REMAIN) {
      // used discount too many times
      return {
        errorMessage: MESSAGE_ERROR_USED,
        invalidReason,
      };
    } else {
      // invalid discount
      return {
        errorMessage: null,
        invalidReason,
      };
    }
  }

  return {
    errorMessage: null,
    invalidReason,
  };
};
